import SignUpForm from "../../components/SignUpForm/SignUpForm";

const SignUpPage = () => {
   return <SignUpForm />;
};

export default SignUpPage;
